module.exports = __webpack_public_path__ + "img/no_img.0178b016.png";